import MenuLateral from "../MenuLateral/menulateral";
import MenuLateralMobile from "../MenuLateral/menulateralmobile";
import IVendaTabela from "./tabela";

function Listagem() {  
  
    return (
        <div class="container-fluid">
            <div class="row">
                <MenuLateral menu="ivenda" admin={false}/>
                <MenuLateralMobile />
                <div class="col-12 col-lg-2 mobile-hide invisible"></div>            
                <div id="conteudo" class="col-12 col-lg-10">
                    <IVendaTabela />
                </div>           
            </div>
        </div>  
    );
  
  }
  
  export default Listagem;